module.exports = __webpack_public_path__ + "static/media/whyApplyImage.cff6ce14.svg";